import { createSectionTitle, createSummaryTitle, createTable, parseHtmlContent } from '../utils';

export const renderCurrentMedications = (data, title) => {
  const content = [];

  content.push(createSectionTitle(title));

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if medication data is meaningful
  const hasValidMedications = (medications) => {
    if (!medications || !Array.isArray(medications) || medications.length === 0) return false;
    return medications.some((med) => {
      return (
        (med.medication && med.medication.trim() !== '') ||
        (med.strength && med.strength.trim() !== '') ||
        (med.unit && med.unit.trim() !== '') ||
        (med.sig && med.sig.trim() !== '') ||
        med.start_date ||
        med.end_date ||
        (med.prescriber &&
          (med.prescriber.label ||
            med.prescriber.value ||
            (typeof med.prescriber === 'string' && med.prescriber.trim() !== '')))
      );
    });
  };

  // Check if there's any meaningful data to display
  const hasRows = hasValidMedications(data.medications);
  const hasNarrative = data && data.narrative && data.narrative.trim() !== '';

  // If no meaningful data and no narrative, show "No data"
  if (!hasRows && !hasNarrative) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  if (hasRows) {
    const headers = ['Medication', 'Status', 'Dose', 'Prescriber', 'Start date', 'End date'];
    const rows = data.medications
      .filter((med) => {
        // Filter out empty rows
        const hasMedication = med.medication && med.medication.trim() !== '';
        const hasDose =
          (med.strength && med.strength.trim() !== '') ||
          (med.unit && med.unit.trim() !== '') ||
          (med.sig && med.sig.trim() !== '');
        const hasPrescriber =
          med.prescriber &&
          (med.prescriber.label ||
            med.prescriber.value ||
            (typeof med.prescriber === 'string' && med.prescriber.trim() !== ''));
        const hasDates = med.start_date || med.end_date;
        return hasMedication || hasDose || hasPrescriber || hasDates;
      })
      .map((med) => {
        const startDate = med.start_date ? new Date(med.start_date).toLocaleDateString() : '';
        const endDate = med.end_date ? new Date(med.end_date).toLocaleDateString() : '';

        const prescriberInfo = med.prescriber
          ? med.prescriber.label || med.prescriber.value || med.prescriber
          : '';

        const status = med.is_past ? 'Past' : 'Current';

        let doseInfo = '';
        if (med.strength && med.unit) {
          doseInfo = `${med.strength} ${med.unit}`;
        }
        if (med.sig) {
          doseInfo = doseInfo ? `${doseInfo} - ${med.sig}` : med.sig;
        }

        return [
          { text: med.medication || '-', style: 'tableCell' },
          { text: status || '-', style: 'tableCell' },
          { text: doseInfo || '-', style: 'tableCell' },
          { text: prescriberInfo || '-', style: 'tableCell' },
          { text: startDate || '-', style: 'tableCell' },
          { text: endDate || '-', style: 'tableCell' }
        ];
      });

    if (rows.length > 0) {
      content.push(createTable(headers, rows, ['18%', '12%', '12%', '30%', '14%', '14%']));
    }
  }

  // Show narrative if it exists
  if (hasNarrative) {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
